<template>
	<footer class="footer" style=" text-align:center; display:block">
			<div class="copyright">
				<!-- <img alt="Logo" :src="darkTheme ? 'images/logo-dark.svg' : 'images/logo-white.svg'" height="20" class="mr-2" /> -->
				{{getYear}} © made AGF team software 
			</div>     
      <div v-if="!currentUser.user[0].validate_agenzie.length">
         <img class="palleggia" src="../src/assets/img/fuochi-d-artificio-immagine-animata-0080.gif" />
         <p class="claim">la rivoluzione si può fare</p>
      </div>
      </footer>
</template>

<script>
	import { useStore } from 'vuex'
	import { onMounted, ref } from 'vue';


	export default {
		name: "AppFooter",
		computed: {
			getYear() {
				return new Date().getFullYear();
			}
		},
		setup(){
			const store = useStore()
			const currentUser = ref({user:[{email: '', validate_agenzie: ''}]})

			onMounted(() => {
				currentUser.value = JSON.parse(atob(store.state.auth.user))
			})

			return {
				currentUser
			}
		}
	}
</script>

<style scoped>
.footer {
	padding: 20px;
	display: block;
}
.palleggia {
margin-top: 10px;
  width: 50px;
}
.claim {
  font-size: 8px;
  text-transform: uppercase;
}
</style>
